module.exports = "/_next/static/images/timPv-d5d09e28adba2666985c056d4c9f6689.png";